import React from "react";

/** Libraries */
import { Provider } from "react-redux";

/** Store */
import ReactDOM from "react-dom/client";
import { PrimeReactProvider } from "primereact/api";

/** App */
import App from "./App";

/** Store */
import { store } from "./app/store";

/** CSS */
import "@moltech/molui/molui.css";
import "primeicons/primeicons.css";
import "./index.css";
import "./styles/main.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //   <PrimeReactProvider value={{ unstyled: false, pt: Tailwind }}  >
  <PrimeReactProvider value={{ unstyled: false }}>
    <Provider store={store}>
      <App />
    </Provider>
  </PrimeReactProvider>,
);
